<template>
  <div class="m-5 xl:m-15 2xl:m-20">
    <!-- BEGIN Popup compare cartography -->
    <PopupCompareCarto
      :compare-carto="compareCarto"
      @close="closeCompare"
      @changeCompare="
        (index) => {
          changeCompare(index);
        }
      "
      :carto-to-compare="cartoToCompare"
      :history-to-display="historyToDisplay"
      :competences-cles="{}"
      :history-competences-cles="[]"
      :competences-informatique="{}"
      :history-competences-informatique="[]"
      :competences-linguistique="{}"
      :history-competences-linguistique="[]"
      :competences-socio-pro="{}"
      :history-competences-socio-pro="{}"
      :competences-pro="competencesPro"
      :history-competences-pro="historyCompetencesPro"
      :is-beneficiary="infosPass.id_pass === user.id"
      v-if="compareCarto"
    />
    <!-- END Popup compare cartography -->

    <div
      v-if="
        Object.keys(competencesPro).length > 0 ||
          Object.keys(historyCompetencesPro).length > 0
      "
    >
      <h3 class="mb-10">
        Compétences professionnelles
      </h3>

      <!-- BEGIN list postes -->
      <div class="flex justify-center">
        <div
          class="flex flex-row self-center relative justify-end items-center cursor-pointer my-8 w-max-content w-max"
          @click="displayFieldList"
          @click.stop
        >
          <div
            v-if="listCompetencesPro.length > 0"
            class="flex flex-row ml-auto items-end"
          >
            <h3 class="text-xl text-indigo-600">
              {{ currentPoste }}
            </h3>
          </div>
          <div
            v-if="listCompetencesPro.length > 1"
            class="text-pink-600 max-h-8 mr-auto rounded-full relative inline-flex items-center p-2 order-2"
          >
            <icon
              class="h-4 w-4"
              name="chevron-down"
            />
          </div>
          <div
            class="fieldlist z-20 w-max-content w-max mt-2 absolute rounded-md bg-white flex transform translate-y-full self-end shadow-md shadow-gray-600 text-sm"
            v-click-outside="displayFieldList"
            v-if="showList"
          >
            <div class="mx-5 my-3">
              <div class="text-left">
                <div
                  class="first:pt-2 py-1"
                  v-for="(field, i) in listCompetencesPro"
                  :key="i"
                >
                  <p
                    class="text-gray-600 hover:text-gray-900"
                    @click="selectedPoste = field.name"
                  >
                    <span>{{ field.name }} </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END list postes -->

      <div
        v-for="(pro, index) in listCompetencesPro"
        :key="index"
        class="my-10"
      >
        <div v-if="competencesPro[pro.name] || historyCompetencesPro[pro.name]">
          <!-- Case there is a current evaluation -->
          <div v-if="competencesPro[pro.name] && selectedPoste == pro.name">
            <!-- Evaluation for fiche de poste NEOPASS -->
            <div v-if="(competencesPro[pro.name][0] || []).type === 'pro'">
              <div
                v-for="(activity, indexActivity) in competencesPro[pro.name]"
                :key="indexActivity"
              >
                <radar
                  :id-chart="'comppro' + indexActivity"
                  :title="activity.title"
                  :labels="activity.labels"
                  :values="
                    activity.values.filter(
                      (v) =>
                        v.label != 'Référent' || infosPass.id_pass != user.id
                    )
                  "
                  :max="activity.max"
                  :height="150"
                />
                <div
                  v-if="
                    $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE)
                  "
                  class="mt-8 w-full text-center flex justify-center"
                >
                  <action-button
                    class="py-2"
                    border-color="transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    libelle="Comparer"
                    :is-disabled="cantCompare(pro.name)"
                    :enable-action="!cantCompare(pro.name)"
                    disabled-tooltip="Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
                    @clickAction="
                      displayCompareCarto(
                        'comppro/' + pro.name + '/' + indexActivity
                      )
                    "
                  />
                </div>
              </div>
            </div>

            <!-- Current evaluation for Fiche Code ROME -->
            <div v-if="competencesPro[pro.name].type === 'ROME'">
              <h3>Compétences de base</h3>
              <div>
                <div>
                  <multi-pie
                    id-chart="romeCompetencesBasesSavoirFaire"
                    title="Savoir-faire"
                    :labels="competencesPro[pro.name].longLabels"
                    :sub-labels="['Référent', 'Auto-évaluation']"
                    :values="[
                      [
                        competencesPro[pro.name].datas[0]['competences_bases'][
                          'savoir_faire'
                        ]['referent'],
                        competencesPro[pro.name].datas[1]['competences_bases'][
                          'savoir_faire'
                        ]['referent'],
                      ],
                      [
                        competencesPro[pro.name].datas[0]['competences_bases'][
                          'savoir_faire'
                        ]['auto'],
                        competencesPro[pro.name].datas[1]['competences_bases'][
                          'savoir_faire'
                        ]['auto'],
                      ],
                    ]"
                    :colors="competencesPro[pro.name].colors"
                    position-legend="bottom"
                    height="400"
                    thickness="50"
                  />
                </div>
                <div
                  v-if="
                    $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE)
                  "
                  class="mt-5 w-full text-center flex justify-center"
                >
                  <action-button
                    class="py-2"
                    border-color="transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    libelle="Comparer"
                    :is-disabled="cantCompare(pro.name)"
                    :enable-action="!cantCompare(pro.name)"
                    disabled-tooltip="Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
                    @clickAction="
                      displayCompareCarto(
                        'compproRome/' +
                          pro.name +
                          '/competences_bases/savoir_faire'
                      )
                    "
                  />
                </div>
              </div>
              <div>
                <div>
                  <multi-pie
                    id-chart="romeCompetencesBasesSavoirs"
                    title="Savoirs"
                    :labels="competencesPro[pro.name].longLabels"
                    :sub-labels="['Référent', 'Auto-évaluation']"
                    :values="[
                      [
                        competencesPro[pro.name].datas[0]['competences_bases'][
                          'savoirs'
                        ]['referent'],
                        competencesPro[pro.name].datas[1]['competences_bases'][
                          'savoirs'
                        ]['referent'],
                      ],
                      [
                        competencesPro[pro.name].datas[0]['competences_bases'][
                          'savoirs'
                        ]['auto'],
                        competencesPro[pro.name].datas[1]['competences_bases'][
                          'savoirs'
                        ]['auto'],
                      ],
                    ]"
                    :colors="competencesPro[pro.name].colors"
                    position-legend="bottom"
                    height="400"
                    thickness="50"
                  />
                </div>
                <div
                  v-if="
                    $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE)
                  "
                  class="mt-5 w-full text-center flex justify-center"
                >
                  <action-button
                    class="py-2"
                    border-color="transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    libelle="Comparer"
                    :is-disabled="cantCompare(pro.name)"
                    :enable-action="!cantCompare(pro.name)"
                    disabled-tooltip="Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
                    @clickAction="
                      displayCompareCarto(
                        'compproRome/' + pro.name + '/competences_bases/savoirs'
                      )
                    "
                  />
                </div>
              </div>

              <h3>Compétences spécifiques</h3>

              <div>
                <div>
                  <multi-pie
                    id-chart="romeCompetencesSpeSavoirFaire"
                    title="Savoir-faire"
                    :labels="competencesPro[pro.name].longLabels"
                    :sub-labels="['Référent', 'Auto-évaluation']"
                    :values="[
                      [
                        competencesPro[pro.name].datas[0]['competences_spe'][
                          'savoir_faire'
                        ]['referent'],
                        competencesPro[pro.name].datas[1]['competences_spe'][
                          'savoir_faire'
                        ]['referent'],
                      ],
                      [
                        competencesPro[pro.name].datas[0]['competences_spe'][
                          'savoir_faire'
                        ]['auto'],
                        competencesPro[pro.name].datas[1]['competences_spe'][
                          'savoir_faire'
                        ]['auto'],
                      ],
                    ]"
                    :colors="competencesPro[pro.name].colors"
                    position-legend="bottom"
                    height="400"
                    thickness="50"
                  />
                </div>
                <div
                  class="mt-5 w-full text-center flex justify-center"
                  v-if="
                    $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE)
                  "
                >
                  <action-button
                    class="py-2"
                    border-color="transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    libelle="Comparer"
                    :is-disabled="cantCompare(pro.name)"
                    :enable-action="!cantCompare(pro.name)"
                    disabled-tooltip="Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
                    @clickAction="
                      displayCompareCarto(
                        'compproRome/' +
                          pro.name +
                          '/competences_spe/savoir_faire'
                      )
                    "
                  />
                </div>
              </div>
              <div>
                <div>
                  <multi-pie
                    id-chart="romeCompetencesSpeSavoirs"
                    title="Savoirs"
                    :labels="competencesPro[pro.name].longLabels"
                    :sub-labels="['Référent', 'Auto-évaluation']"
                    :values="[
                      [
                        competencesPro[pro.name].datas[0]['competences_spe'][
                          'savoirs'
                        ]['referent'],
                        competencesPro[pro.name].datas[1]['competences_spe'][
                          'savoirs'
                        ]['referent'],
                      ],
                      [
                        competencesPro[pro.name].datas[0]['competences_spe'][
                          'savoirs'
                        ]['auto'],
                        competencesPro[pro.name].datas[1]['competences_spe'][
                          'savoirs'
                        ]['auto'],
                      ],
                    ]"
                    :colors="competencesPro[pro.name].colors"
                    position-legend="bottom"
                    height="400"
                    thickness="50"
                  />
                </div>
                <div
                  class="mt-5 w-full text-center flex justify-center"
                  v-if="
                    $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE)
                  "
                >
                  <action-button
                    class="py-2"
                    border-color="transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    libelle="Comparer"
                    :is-disabled="cantCompare(pro.name)"
                    :enable-action="!cantCompare(pro.name)"
                    disabled-tooltip="Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
                    @clickAction="
                      displayCompareCarto(
                        'compproRome/' + pro.name + '/competences_spe/savoirs'
                      )
                    "
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- Case Display last evaluation in history -->
          <div
            v-else-if="
              historyCompetencesPro[pro.name] && selectedPoste == pro.name
            "
          >
            <!-- History Evaluation for fiche de poste NEOPASS -->
            <div
              v-if="
                (
                  historyCompetencesPro[pro.name][
                    historyCompetencesPro[pro.name].length - 1
                  ][1][0] || {}
                ).type === 'pro'
              "
            >
              <div
                v-for="(activity, indexActivity) in historyCompetencesPro[
                  pro.name
                ][historyCompetencesPro[pro.name].length - 1][1]"
                :key="indexActivity"
              >
                <radar
                  :id-chart="'comppro' + indexActivity"
                  :title="activity.title"
                  :labels="activity.labels"
                  :values="activity.values"
                  :max="activity.max"
                  :height="150"
                />
                <div
                  class="mt-8 w-full text-center flex justify-center"
                  v-if="
                    $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE)
                  "
                >
                  <action-button
                    class="py-2"
                    border-color="transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    libelle="Comparer"
                    :is-disabled="cantCompare(pro.name)"
                    :enable-action="!cantCompare(pro.name)"
                    disabled-tooltip="Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
                    @clickAction="
                      displayCompareCarto(
                        'comppro/' + pro.name + '/' + indexActivity
                      )
                    "
                  />
                </div>
              </div>
            </div>

            <!-- History Evaluation for fiche Code ROME -->
            <div
              v-if="
                historyCompetencesPro[pro.name][
                  historyCompetencesPro[pro.name].length - 1
                ][1].type === 'ROME'
              "
            >
              <h3>Compétences de base</h3>
              <div>
                <div>
                  <multi-pie
                    id-chart="romeCompetencesBasesSavoirFaire"
                    title="Savoir-faire"
                    :labels="competencesPro[pro.name].longLabels"
                    :sub-labels="['Référent', 'Auto-évaluation']"
                    :values="[
                      [
                        historyCompetencesPro[pro.name].datas[0][
                          'competences_bases'
                        ]['savoir_faire']['referent'],
                        historyCompetencesPro[pro.name].datas[1][
                          'competences_bases'
                        ]['savoir_faire']['referent'],
                      ],
                      [
                        historyCompetencesPro[pro.name].datas[0][
                          'competences_bases'
                        ]['savoir_faire']['auto'],
                        historyCompetencesPro[pro.name].datas[1][
                          'competences_bases'
                        ]['savoir_faire']['auto'],
                      ],
                    ]"
                    :colors="
                      historyCompetencesPro[pro.name][
                        historyCompetencesPro[pro.name].length - 1
                      ][1].colors
                    "
                    position-legend="bottom"
                    height="400"
                    thickness="50"
                  />
                </div>
                <div
                  class="mt-5 w-full text-center flex justify-center"
                  v-if="
                    $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE)
                  "
                >
                  <action-button
                    class="py-2"
                    border-color="transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    libelle="Comparer"
                    :is-disabled="cantCompare(pro.name)"
                    :enable-action="!cantCompare(pro.name)"
                    disabled-tooltip="Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
                    @clickAction="
                      displayCompareCarto(
                        'compproRome/' +
                          pro.name +
                          '/competences_bases/savoir_faire'
                      )
                    "
                  />
                </div>
              </div>
              <div>
                <div>
                  <multi-pie
                    id-chart="romeCompetencesBasesSavoirs"
                    title="Savoirs"
                    :labels="competencesPro[pro.name].longLabels"
                    :sub-labels="['Référent', 'Auto-évaluation']"
                    :values="[
                      [
                        historyCompetencesPro[pro.name].datas[0][
                          'competences_bases'
                        ]['savoirs']['referent'],
                        historyCompetencesPro[pro.name].datas[1][
                          'competences_bases'
                        ]['savoirs']['referent'],
                      ],
                      [
                        historyCompetencesPro[pro.name].datas[0][
                          'competences_bases'
                        ]['savoirs']['auto'],
                        historyCompetencesPro[pro.name].datas[1][
                          'competences_bases'
                        ]['savoirs']['auto'],
                      ],
                    ]"
                    :colors="
                      historyCompetencesPro[pro.name][
                        historyCompetencesPro[pro.name].length - 1
                      ][1].colors
                    "
                    position-legend="bottom"
                    height="400"
                    thickness="50"
                  />
                </div>
                <div
                  class="mt-5 w-full text-center flex justify-center"
                  v-if="
                    $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE)
                  "
                >
                  <action-button
                    class="py-2"
                    border-color="transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    libelle="Comparer"
                    :is-disabled="cantCompare(pro.name)"
                    :enable-action="!cantCompare(pro.name)"
                    disabled-tooltip="Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
                    @clickAction="
                      displayCompareCarto(
                        'compproRome/' + pro.name + '/competences_bases/savoirs'
                      )
                    "
                  />
                </div>
              </div>

              <h3 class="mt-15">
                Compétences spécifiques
              </h3>

              <div>
                <div>
                  <multi-pie
                    id-chart="romeCompetencesSpeSavoirFaire"
                    title="Savoir-faire"
                    :labels="competencesPro[pro.name].longLabels"
                    :sub-labels="['Référent', 'Auto-évaluation']"
                    :values="[
                      [
                        historyCompetencesPro[pro.name].datas[0][
                          'competences_spe'
                        ]['savoir_faire']['referent'],
                        historyCompetencesPro[pro.name].datas[1][
                          'competences_spe'
                        ]['savoir_faire']['referent'],
                      ],
                      [
                        historyCompetencesPro[pro.name].datas[0][
                          'competences_spe'
                        ]['savoir_faire']['auto'],
                        historyCompetencesPro[pro.name].datas[1][
                          'competences_spe'
                        ]['savoir_faire']['auto'],
                      ],
                    ]"
                    :colors="
                      historyCompetencesPro[pro.name][
                        historyCompetencesPro[pro.name].length - 1
                      ][1].colors
                    "
                    position-legend="bottom"
                    height="400"
                    thickness="50"
                  />
                </div>
                <div
                  class="mt-5 w-full text-center flex justify-center"
                  v-if="
                    $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE)
                  "
                >
                  <action-button
                    class="py-2"
                    border-color="transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    libelle="Comparer"
                    :is-disabled="cantCompare(pro.name)"
                    :enable-action="!cantCompare(pro.name)"
                    disabled-tooltip="Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
                    @clickAction="
                      displayCompareCarto(
                        'compproRome/' +
                          pro.name +
                          '/competences_spe/savoir_faire'
                      )
                    "
                  />
                </div>
              </div>
              <div>
                <div>
                  <multi-pie
                    id-chart="romeCompetencesSpeSavoirs"
                    title="Savoirs"
                    :labels="competencesPro[pro.name].longLabels"
                    :sub-labels="['Référent', 'Auto-évaluation']"
                    :values="[
                      [
                        historyCompetencesPro[pro.name].datas[0][
                          'competences_spe'
                        ]['savoirs']['referent'],
                        historyCompetencesPro[pro.name].datas[1][
                          'competences_spe'
                        ]['savoirs']['referent'],
                      ],
                      [
                        historyCompetencesPro[pro.name].datas[0][
                          'competences_spe'
                        ]['savoirs']['auto'],
                        historyCompetencesPro[pro.name].datas[1][
                          'competences_spe'
                        ]['savoirs']['auto'],
                      ],
                    ]"
                    :colors="
                      historyCompetencesPro[pro.name][
                        historyCompetencesPro[pro.name].length - 1
                      ][1].colors
                    "
                    position-legend="bottom"
                    height="400"
                    thickness="50"
                  />
                </div>
                <div
                  class="mt-5 w-full text-center flex justify-center"
                  v-if="
                    $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE)
                  "
                >
                  <action-button
                    class="py-2"
                    border-color="transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    libelle="Comparer"
                    :is-disabled="cantCompare(pro.name)"
                    :enable-action="!cantCompare(pro.name)"
                    disabled-tooltip="Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
                    @clickAction="
                      displayCompareCarto(
                        'compproRome/' + pro.name + '/competences_spe/savoirs'
                      )
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-else
      class="flex flex-col justify-center items-center w-full"
    >
      <h6 class="text-pink-600 w-full mb-8">
        Aucune donnée
      </h6>
      <div class="text-indigo-600 text-center text-base mb-8">
        {{ infosPass.name }} n'a pas d'évaluation de compétences
        professionnelles
      </div>
      <div>
        <illustration name="no_result" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Icon from '../../../components/Icon';
import ActionButton from '../../../components/ActionButton';
import Radar from '../../../components/Charts/Radar';
import Pie from '../../../components/Charts/Pie';
import Illustration from '../../../components/Illustration';
import PopupCompareCarto from '../../../components/Cartographies/PopupCompareCarto';
import Constants from '../../../constants';
import MultiPie from '../../../components/Charts/MultiPie.vue';

export default {
  components: {
    Icon,
    ActionButton,
    Radar,
    Illustration,
    Pie,
    PopupCompareCarto,
    MultiPie,
  },

  name: 'Comppro',

  data() {
    return {
      colors: {
        type: 'normal',
        beneficiary: '#21B8C8',
        referent: '#FF1C80',
        true: '#21B8C85A',
        false: '#919AA65A',
      },
      compareCarto: false,
      cartoToCompare: '',
      historyToDisplay: -1,
      toReload: true, //use to hide and show cartography and check changes
      listCompetencesPro: [],
      showList: false,
      selectedPoste: Constants.PAGE_NEOPASS_FORM_POSTE_1,
      constants: Constants,
    };
  },

  created() {
    this.setListCompetencesPro();

    //Select the first poste with evaluation
    this.selectedPoste =
      this.listCompetencesPro.length > 0
        ? this.listCompetencesPro[0].name
        : this.selectedPoste;
  },

  methods: {
    /**
     * Filter competence pro by "n° poste" page with evaluation
     */
    setListCompetencesPro() {
      new Set([...Object.keys(this.competencesPro), ...Object.keys(this.historyCompetencesPro)]).forEach(sheet => {
        this.listCompetencesPro.push({id: sheet, name: sheet});
      });
    },

    /**
     * display popup to compare a cartography
     * @param String typeCarto
     */
    displayCompareCarto(typeCarto) {
      this.compareCarto = true;
      this.cartoToCompare = typeCarto;
    },

    /**
     * Close popup to compare cartography
     */
    closeCompare() {
      this.compareCarto = false;
      this.cartoToCompare = '';
      this.historyToDisplay = -1;
    },

    /**
     * Change the history cartography to compare
     * @param Number index
     */
    changeCompare(index) {
      setTimeout(() => {
        this.historyToDisplay = -1;
      }, 300);
      setTimeout(() => {
        this.historyToDisplay = index;
      }, 300);
    },

    /**
     * /!\ Method not used for the moment
     * User can choose the cartography colors between old (passeport compétences) or new (neopass) colors
     * @param String n
     */
    switchColor(n) {
      switch (n) {
      case 'normal':
        this.colors.beneficiary = '#21B8C8';
        this.colors.referent = '#FF1C80';
        break;
      case 'old':
        this.colors.beneficiary = '#31AFDE';
        this.colors.referent = '#94AC49';
        break;
      default:
        this.colors.beneficiary = '#21B8C8';
        this.colors.referent = '#FF1C80';
        break;
      }

      this.colors.type = n;
      setTimeout(() => {
        this.toReload = false;
      }, 300);
      setTimeout(() => {
        this.toReload = true;
      }, 300);
    },

    /**
     * Display drop down to choose the poste
     */
    displayFieldList() {
      this.showList = !this.showList;
    },

    canCompare(page) {
      //TRUE if there are 2 evals in history
      //TRUE if there is 1 eval in history and 1 current eval
      //FALSE otherwise

      const evalCount = this.historyCompetencesPro?.[page]?.length ?? 0;
      const hasCurrent =
        this.competencesPro?.[page] &&
        Object.values(this.competencesPro?.[page]).length > 0;

      return evalCount >= 2 || (evalCount > 0 && hasCurrent);
    },

    cantCompare(page) {
      return !this.canCompare(page);
    },


  },
  computed: {
    ...mapGetters({
      neopassDatas: 'cartographiesIndividuelles/neopassDatas',
      infosPass: 'cartographiesIndividuelles/infosPass',
      listEvaluations: 'cartographiesIndividuelles/listEvaluations',
      infosPage: 'cartographiesIndividuelles/infosPage',
      user: 'auth/user',
    }),

    competencesPro: function () {
      return (
        (this.neopassDatas || {})[
          Constants.MODULE_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES
        ] || {}
      );
    },

    historyCompetencesPro: function () {
      return (
        (this.listEvaluations || {})[
          Constants.MODULE_NEOPASS_FORM_COMPETENCES_PROFESIONNELLES
        ] || {}
      );
    },

    /**
     * Determine the template type between Job_Desc, Ref_formation or ROME
     */
    typeReferentiel: function () {
      if (this.competencesPro[this.selectedPoste]) {
        return this.competencesPro[this.selectedPoste].type
          ? this.competencesPro[this.selectedPoste].type
          : this.competencesPro[this.selectedPoste][0].type;
      } else if (this.historyCompetencesPro[this.selectedPoste]) {
        return this.historyCompetencesPro[this.selectedPoste][
          this.historyCompetencesPro[this.selectedPoste].length - 1
        ][1].type
          ? this.historyCompetencesPro[this.selectedPoste][
            this.historyCompetencesPro[this.selectedPoste].length - 1
          ][1].type
          : this.historyCompetencesPro[this.selectedPoste][
            this.historyCompetencesPro[this.selectedPoste].length - 1
          ][1][0].type;
      }
      return [];
    },

    /**
     * Determine the selected poste
     */
    currentPoste: function () {
      let jobName = '';

      if (this.competencesPro[this.selectedPoste]) {
        jobName =
          this.typeReferentiel === 'ROME'
            ? this.competencesPro[this.selectedPoste].title
            : this.competencesPro[this.selectedPoste][0].title;
      } else if (this.historyCompetencesPro[this.selectedPoste]) {
        jobName =
          this.typeReferentiel === 'ROME'
            ? this.historyCompetencesPro[this.selectedPoste][
              this.historyCompetencesPro[this.selectedPoste].length - 1
            ][1].title
            : this.historyCompetencesPro[this.selectedPoste][
              this.historyCompetencesPro[this.selectedPoste].length - 1
            ][1][0].title;
      }

      return jobName;
    },
  },
};
</script>
